import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { IntegrationConfiguration } from '../models/integrationConfig';

@Injectable({ providedIn: 'root' })
export class VoucherService {
  constructor(private api: ApiService) {}

  unreadNotifications = 0;

  PATH = 'v1/voucher';

  getVoucher(merchant: string) {
    return this.api.get(`${this.PATH}/${merchant}`);
  }

  getVouchers(limit: number, page: number, includeUnlisted?: boolean) {
    var query = `?limit=${limit}&page=${page}`;
    if (includeUnlisted) {
      query += '&includeUnlisted=true';
    }
    return this.api.get(`${this.PATH}/list` + query);
  }

  createVoucher(payload: any) {
    return this.api.post(`${this.PATH}`, payload);
  }

  editVoucher(payload: any) {
    return this.api.post(`${this.PATH}/edit`, payload);
  }

  toggleVoucher(payload: any) {
    return this.api.post(`${this.PATH}/toggle`, payload);
  }

  getVoucherByCode(code: string) {
    return this.api.get(`${this.PATH}/code/${code}`);
  }

  issueVoucher(payload: any) {
    return this.api.post(`${this.PATH}/issue`, payload);
  }

  redeemVoucherByCode(code: string) {
    return this.api.post(`${this.PATH}redeem/code/${code}`, {});
  }

  searchVouchers(searchTerm: string, limit: number = 10) {
    return this.api.get(`${this.PATH}/search?q=${searchTerm}&limit=${limit}`);
  }

  sendVoucherEmail(voucherCode: string) {
    return this.api.post(`${this.PATH}/send-email`, { voucherCode });
  }

  downloadVoucherPDF(userVoucherId: string) {
    return this.api.downloadFile(
      `${this.PATH}/user-voucher/${userVoucherId}/download`,
    );
  }

  previewVoucherPDF(voucherNanoid: string) {
    return this.api.downloadFile(`${this.PATH}/${voucherNanoid}/preview-pdf`);
  }

  sendTestVoucherEmail(voucherNanoid: string, email: string) {
    return this.api.post(`${this.PATH}/${voucherNanoid}/send-test-email`, {
      email,
    });
  }

  updateVoucherOrder(payload: { voucherId: string; displayOrder: number }) {
    return this.api.post(`${this.PATH}/update-order`, payload);
  }
}
